import { registerPropertyManagerSection } from '@/core';
import AssembleReferencePlanePropertySection from '@/components/editor/property-manager/assemble-reference/AssembleReferencePlanePropertySection.vue';

registerPropertyManagerSection({
  id: 'assembly-reference-plane',
  title: '装配体基准面',
  order: 35,
  component: AssembleReferencePlanePropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) =>
    context.activeCommand === 'assembly-reference-plane'
    || Boolean(context.assemblyReferencePlaneActive),
  onConfirm: (context) => {
    context.submitAssemblyReferencePlane?.();
  },
  onCancel: (context) => {
    context.cancelAssemblyReferencePlane?.();
  },
});
